import { Link } from "react-router-dom";
import BrandLogo from "../Shared/Brand/BrandLogo";
import { getMarketingUrl } from "../../utility/environment";

const Header = ({ title, subtitle, showBackToSignIn = false }) => {
  return (
    <div className="w-full">
      <a href={getMarketingUrl()} target="_blank" rel="noopener noreferrer" className="inline-block">
        {/* Brand logos paint their own colors; no className tint applied. */}
        <BrandLogo className="h-10 w-auto" />
      </a>
      <h2 className="mt-10 font-display text-4xl sm:text-5xl tracking-display text-ink-900 leading-[1.05]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 text-sm leading-6 text-ink-500">
          {subtitle}
        </p>
      )}
      {showBackToSignIn && (
        <p className="mt-3 text-sm leading-6 text-ink-500">
          Or{" "}
          <Link
            to="/signin"
            className="font-medium text-accent-600 hover:text-accent-700 underline-offset-2 hover:underline"
          >
            back to sign in
          </Link>
        </p>
      )}
    </div>
  );
};

export default Header;
